import React, { useEffect } from 'react';

import { LoaderSpinner } from '@vw-marketing/us-components';

import { useAuth } from '../../app/providers/AuthContext';
import { useHistory } from '../../shared/hooks/use-history';

interface MainLayoutProps {
  children?: React.ReactNode;
}

export const ProtectedRoute: React.FC<MainLayoutProps> = ({ children }) => {
  const { isAuthenticated, sufficiencyChecksComplete, loading, logout } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && isAuthenticated && !sufficiencyChecksComplete) {
      logout();
    } else if (!loading && !isAuthenticated) {
      history.push('/');
    }
  }, [loading, isAuthenticated, sufficiencyChecksComplete, logout, history]);

  // Show loading while auth is being validated or checks are being executed
  if (loading) {
    return <LoaderSpinner />;
  }

  if (isAuthenticated && sufficiencyChecksComplete) {
    return <>{children}</>;
  }

  return null;
};
